import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

import OurServices from './ourServices';
import ExploreServices from './exploreServices';
import TopPortfolios from './topPortfolios';
import TechnologiesSection from './technologiesSection';
import WhoWeAre from './whoWeAre';

import mascot from '../../assets/mascot.PNG';

const heroChips = [
  { title: 'Designs', description: 'Products your users love' },
  { title: 'Builds', description: 'Systems that scale with you' },
];

function LandingScreen() {
  return (
    <main className="landing-page relative isolate overflow-hidden bg-white transition-colors duration-300 dark:bg-dark-bg">
      <section className="relative isolate overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 pt-28 sm:pt-36 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="relative overflow-hidden rounded-2xl border border-gray-200 bg-white p-8 dark:border-white/10 dark:bg-primary-dark sm:p-12 lg:p-16"
          >
            <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-secondary/25 blur-3xl dark:bg-secondary/10" />

            <div className="relative grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end lg:gap-16">
              <div>
                <h1 className="text-4xl font-bold uppercase leading-[1.15] tracking-tight text-gray-950 dark:text-white sm:text-5xl lg:text-6xl">
                  Afroawi designs and builds{' '}
                  <ArrowRightIcon
                    className="inline-block h-8 w-8 shrink-0 align-middle text-secondary-dark dark:text-secondary sm:h-10 sm:w-10"
                    aria-hidden="true"
                  />{' '}
                  software that moves businesses forward.
                </h1>

                <div className="mt-8 grid max-w-md grid-cols-2 gap-3 sm:gap-4">
                  {heroChips.map((chip) => (
                    <div key={chip.title} className="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-white/10 dark:bg-white/5">
                      <span className="mb-2 inline-block h-2 w-2 rounded-sm bg-secondary" aria-hidden="true" />
                      <p className="text-sm font-semibold text-gray-950 dark:text-white">{chip.title}</p>
                      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{chip.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-center gap-5 lg:items-end">
                <img
                  src={mascot}
                  alt="Afroawi mascot"
                  className="h-56 w-auto object-contain sm:h-64 lg:h-72"
                />
                <p className="max-w-xs text-center text-sm leading-6 text-gray-500 dark:text-gray-400 lg:text-right">
                  We combine strategic thinking with hands-on engineering to ship products that last.
                </p>
                <Link
                  to="/request-meeting"
                  className="inline-flex items-center gap-2 rounded-lg bg-secondary px-5 py-3 text-sm font-semibold text-primary transition duration-200 hover:bg-secondary-dark"
                >
                  Start a Project
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <div className="relative z-10">
        <WhoWeAre/>
        <OurServices/>
        <ExploreServices/>
        <TechnologiesSection/>
        <TopPortfolios/>
      </div>
    </main>
  );
}

export default LandingScreen;
